export default function HandshakeIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M38.4892 32.3449C38.7527 32.6081 39.0669 32.8151 39.4127 32.9532C39.7586 33.0913 40.1289 33.1577 40.5011 33.1483C40.8734 33.139 41.2399 33.0541 41.5784 32.8988C41.9169 32.7435 42.2203 32.521 42.4702 32.2449C42.9391 31.7269 43.1931 31.0498 43.1807 30.3512C43.1683 29.6526 42.8903 28.9849 42.4032 28.4839L32.3872 18.2109"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.4941 38.3867L29.7881 39.6807C30.0504 39.943 30.2585 40.2543 30.4004 40.5969C30.5423 40.9396 30.6154 41.3068 30.6154 41.6777C30.6154 42.0486 30.5423 42.4159 30.4004 42.7585C30.2585 43.1012 30.0504 43.4125 29.7881 43.6747C29.4325 44.0312 28.9877 44.2858 28.5001 44.4117"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5112 30.3672L39.2682 33.1252C39.5324 33.3892 39.742 33.7027 39.885 34.0478C40.028 34.3928 40.1016 34.7627 40.1016 35.1362C40.1016 35.5097 40.028 35.8796 39.885 36.2246C39.742 36.5697 39.5324 36.8832 39.2682 37.1472C39.0042 37.4114 38.6907 37.621 38.3457 37.764C38.0006 37.907 37.6307 37.9806 37.2572 37.9806C36.8837 37.9806 36.5139 37.907 36.1688 37.764C35.8238 37.621 35.5103 37.4114 35.2462 37.1472L32.4902 34.3902"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.7001 36.6016C34.9623 36.8638 35.1704 37.1751 35.3123 37.5178C35.4543 37.8604 35.5273 38.2277 35.5273 38.5986C35.5273 38.9694 35.4543 39.3367 35.3123 39.6793C35.1704 40.022 34.9623 40.3333 34.7001 40.5956C34.1702 41.1248 33.4519 41.422 32.7031 41.422C31.9542 41.422 31.2359 41.1248 30.7061 40.5956"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2111 31.7352L9.46511 32.4812C8.35446 33.5918 8.35446 35.3925 9.46511 36.5032C10.5758 37.6139 12.3765 37.6139 13.4871 36.5032L14.2331 35.7572C15.3438 34.6466 15.3438 32.8458 14.2331 31.7352C13.1225 30.6245 11.3218 30.6245 10.2111 31.7352Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6783 39.2978L18.2972 39.6789C17.1943 40.7818 17.1943 42.5698 18.2972 43.6727C19.4 44.7755 21.1881 44.7755 22.2909 43.6727L22.672 43.2915C23.7749 42.1887 23.7749 40.4006 22.672 39.2978C21.5692 38.1949 19.7811 38.1949 18.6783 39.2978Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1999 31.7439L9.77988 32.1639C9.51643 32.4271 9.20224 32.634 8.85639 32.7721C8.51054 32.9102 8.14023 32.9766 7.76795 32.9672C7.39566 32.9579 7.02916 32.873 6.69067 32.7177C6.35219 32.5624 6.04879 32.34 5.79888 32.0639C5.32937 31.5459 5.07476 30.8685 5.08684 30.1695C5.09891 29.4705 5.37676 28.8023 5.86388 28.3009L6.28388 27.8709C6.79059 27.353 7.48094 27.0557 8.20533 27.0434C8.92973 27.031 9.62982 27.3046 10.1539 27.8049C10.4195 28.0582 10.6317 28.3621 10.7781 28.6987C10.9245 29.0352 11.0021 29.3977 11.0064 29.7647C11.0107 30.1317 10.9415 30.4958 10.803 30.8357C10.6645 31.1756 10.4595 31.4844 10.1999 31.7439Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.5001 22.5018V19.1268L45.5001 16.0748L35.0581 5.63281L33.1901 7.50181H28.5001C26.1658 7.50129 23.9255 8.42114 22.2651 10.0618L15.6001 16.9928C15.1778 17.4309 14.9326 18.0098 14.9116 18.6179C14.8907 19.2261 15.0955 19.8205 15.4866 20.2866C15.8778 20.7527 16.4275 21.0576 17.0301 21.1426C17.6326 21.2276 18.2453 21.0866 18.7501 20.7468L25.8501 16.1718C26.4627 16.8668 27.2179 17.4216 28.0642 17.7985C28.9105 18.1754 29.8281 18.3656 30.7545 18.3561C31.6809 18.3466 32.5943 18.1377 33.4327 17.7435C34.2711 17.3493 35.0148 16.7792 35.6131 16.0718"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 22.5018V19.1268L3.5 16.0748L13.942 5.63281L15.81 7.50181H19.5"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.2493 35.7409L14.0379 35.9523C12.935 37.0552 12.935 38.8432 14.0379 39.9461C15.1407 41.0489 16.9288 41.0489 18.0316 39.9461L18.243 39.7347C19.3459 38.6318 19.3459 36.8438 18.243 35.7409C17.1402 34.6381 15.3522 34.6381 14.2493 35.7409Z"
        stroke="inherit"
        strokeWidth="inherit"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
